// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import React from 'react';

import HomeV2 from '../homev2/HomeV2';
import Home from '../home/Home';
import { FEATURE_FLAG } from '../../../lib/featureFlags';
import { useFeatureFlag } from '../../../lib/state';

/**
 * This functions determines which Home component to render based on the value of the feature flag
 * @returns {JSX.Element}
 */
function HomeDispatcher() {
  const isEnterpriseGradeTSEnabled = useFeatureFlag(FEATURE_FLAG.ENTERPRISE_GRADE_TS);

  if (isEnterpriseGradeTSEnabled) {
    return <HomeV2 />;
  }

  return <Home />;
}

export default HomeDispatcher;
